import { Dialog } from 'quasar';
import ChangeActionDialog from 'components/ChangeActionDialog.vue';

export function showChangeActionDialog(
  message: string,
  options: {
    accountKey?: string;
    forceType?: 'account' | 'user' | 'device';
    historyId?: number;
    historyIds?: number[];
    icon?: string;
    seamless?: boolean;
    serial?: string;
    timeout?: number;
  }
) {
  const {
    accountKey,
    forceType,
    historyId,
    historyIds,
    icon = 'check',
    seamless = true,
    serial,
    timeout = 10000,
  } = options;
  const dialog = Dialog.create({
    component: ChangeActionDialog,
    componentProps: {
      accountKey,
      forceType,
      historyId,
      historyIds,
      icon,
      message,
      seamless,
      serial,
      timeout,
      type: 'positive',
    },
  }).onOk(() => {
    dialog.hide();
  });
}
